import Vue from "vue";
import {
  Button, Toast, CellGroup, Field,  Dialog, Swipe, SwipeItem,Popup,Picker, Icon, Checkbox, CheckboxGroup,Form
  ,Radio,RadioGroup,DropdownMenu, DropdownItem,Search,Loading,Popover,DatetimePicker
  ,Tabs,Tab
 } from "vant";

 export default () => {
  let els = [
    Button, Toast, CellGroup, Field,  Dialog, Swipe, SwipeItem,Popup,Picker, Icon, Checkbox, CheckboxGroup,Form
   ,Radio,RadioGroup,DropdownMenu, DropdownItem,Search,Loading,Popover,DatetimePicker
   ,Tabs,Tab
  ];
  // 注册
  els.forEach((item) => {
    Vue.use(item);
  })
  Vue.prototype.$toast = Toast;
  Vue.prototype.$dialog = Dialog;
}
